import React from 'react';
import {Button,Dialog } from '@material-ui/core'
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import {isNull,isEmpty} from 'lodash'
import 'moment/locale/sv';
import moment from "moment/moment";
import {useSelector, useDispatch} from 'react-redux'
import {getMoteByUserIDByDate33} from 'actions'
import SelectMedArbetare from '../SelectMedArbetare'
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

const localizer = momentLocalizer(moment);
const messages = {
  today: <IntlMessages id="Calendar.Today"/>,
    day: <IntlMessages id="Calendar.Day"/>,
    week: <IntlMessages id="Calendar.Week"/>,
    previous: <IntlMessages id="Calendar.Previous"/>,
    next: <IntlMessages id="Calendar.next"/>,
    month: <IntlMessages id="Calendar.Month"/>,
    allDay: <IntlMessages id="Calendar.Allday"/>,
    date: <IntlMessages id="Calendar.Date"/>,
    time: <IntlMessages id="Calendar.Time"/>,
    event: <IntlMessages id="Calendar.Event"/>,
  };
class CustomToolbar extends React.Component {
  render() {
    console.log(this.props,"Calendar")
    let date = moment(this.props.date).endOf("week").format("YYYY-MM-DD")
    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <button type="button" onClick={() => {
            this.navigate("PREV")
          }}
           disabled={date <= moment(new Date()).endOf("week").format("YYYY-MM-DD")}
          >
            {"<"}
          </button>
        </span>
        <span className="rbc-btn-group pull-right">
          <button type="button" onClick={() => this.navigate("TODAY")}>
          <IntlMessages id="Calendar.Today"/>
          </button>
        </span>
        <span className="rbc-toolbar-label">{this.props.label}</span>
        <span className="rbc-btn-group">
          <button type="button"          
          onClick={() =>{
            this.navigate("NEXT")
          }}>
            {">"}
          </button>
        </span>
      </div>
    );
  }

  navigate = action => {
    this.props.onNavigate(action);
  };
}
function AnsvarigDateRange(props) {
    const dispatch = useDispatch()  
    const EventListByUser= useSelector(state => state.Event.EventListByUserDate)
    const visaOutlookSubject= useSelector(state => state.Event.visaOutlookSubject)
    const visaGsuitSubject= useSelector(state => state.Event.visaGsuitSubject)
    const auth = useSelector(state => state.auth.authUser)
    const [open, setOpen] = React.useState(false)
    const [data,setData] = React.useState([])
    const [selectedDate,setSelectedDate] = React.useState(null)
    const [isLoading,setisLoading] = React.useState(true)
    const [ansvarig,setansvarig] = React.useState(props.ansvarig)
    const PrivatLabel = props.intl.formatMessage({ id: 'Private' });
    const BookedLabel = props.intl.formatMessage({ id: 'Booked' });
    const AdressLabel = props.intl.formatMessage({ id: 'input.Address' });
    const ReservedLabel = props.intl.formatMessage({ id: 'Reserved' });
    const [dateRange,setdateRange] = React.useState({
      start:moment(props.startDate).startOf("week").format("YYYY-MM-DD"),
      end:moment(props.startDate).endOf("week").format("YYYY-MM-DD")
    })
    const handleClickOpen = ()=>{
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false);
    };
    React.useEffect(()=>{
      if(open === true){
      let userlist = []
      userlist.push(props.ansvarig)
      setansvarig(props.ansvarig)
      setdateRange({
          start:moment(props.startDate).startOf("week").format("YYYY-MM-DD"),
          end:moment(props.startDate).endOf("week").format("YYYY-MM-DD")
      })
      dispatch(getMoteByUserIDByDate33(auth.user_Afid,auth.user_id,userlist,moment(props.startDate).startOf("week").format("YYYY-MM-DD"),moment(props.startDate).endOf("week").format("YYYY-MM-DD"),()=>{
        setisLoading(true)
      },()=>{
        setisLoading(false)
      }))
      
      }else{
        setData([])
        setisLoading(true)
      }
    },[open])
    React.useEffect(()=>{
        creatData()
    },[EventListByUser])
    const creatData=()=>{
      if(isEmpty(EventListByUser)){
        setData([]) 
    } 
      else{
        let data =EventListByUser.map((n)=>{
          return {
            id:n,
            title:n.id === 0?
            (ansvarig === auth.user_id)?n.Subject:parseInt(auth.user_role)=== 4?BookedLabel:
            n.From==="Outlook"?parseInt(visaOutlookSubject) === 1? n.isPrivate === 1?PrivatLabel:n.Subject:n.isPrivate === 1?PrivatLabel:BookedLabel :
            n.From==="Gsuit"?parseInt(visaGsuitSubject) === 1? parseInt(n.isPrivate) === 1?PrivatLabel:n.Subject :parseInt(n.isPrivate) === 1?PrivatLabel:BookedLabel
            :n.isPrivate === 1?PrivatLabel:BookedLabel:n.Subject,
            allDay:false,
            start:new Date(`${n.Start}`),
            end:new Date(`${n.End}`),
            tooltip:parseInt(auth.user_role)=== 4?BookedLabel:n.id === 0?(ansvarig === auth.user_id)?`${n.Subject}${isEmpty(n.Adress)?"":`, ${AdressLabel}:${n.Adress}`}`:
            n.From==="Outlook"?parseInt(visaOutlookSubject) === 1? n.isPrivate === 1?PrivatLabel:`${n.Subject}${isEmpty(n.Adress)?"":`, ${AdressLabel}:${n.Adress}`}` :n.isPrivate === 1?PrivatLabel:BookedLabel:
            n.From==="Gsuit"?parseInt(visaGsuitSubject) === 1? n.isPrivate === 1?PrivatLabel:`${n.Subject}${isEmpty(n.Adress)?"":`, ${AdressLabel}:${n.Adress}`}`:n.isPrivate === 1?PrivatLabel:BookedLabel:
            n.isPrivate === 1?PrivatLabel:BookedLabel:`${n.Subject}${isEmpty(n.Adress)?"":`, ${AdressLabel}:${n.Adress}`}`,
            color:n.color
          }
        })
        setData(data)
      }
    }
    const minTime = new Date();
    minTime.setHours(6,30,0);
    const handleNavigate=(date, view, action)=>{
      let userlist = []
      userlist.push(ansvarig)
      setdateRange({
        start:moment(date).startOf("week").format("YYYY-MM-DD"),
        end:moment(date).endOf("week").format("YYYY-MM-DD")
    })
      dispatch(getMoteByUserIDByDate33(auth.user_Afid,auth.user_id,userlist,moment(date).startOf("week").format("YYYY-MM-DD"),moment(date).endOf("week").format("YYYY-MM-DD"),()=>{
        setisLoading(true)
      },()=>{
        setisLoading(false)
      }))
    }
    const onSelectSlot = (slot)=>{
      setSelectedDate({
        start:moment(new Date(`${slot.start}`)).format("YYYY-MM-DD HH:mm:ss"),
        end:moment(new Date(`${slot.end}`)).format("YYYY-MM-DD HH:mm:ss")
      })
      let data1 = data.filter(item=>item.id !== "")
      data1.push({
        id:"",
        title:ReservedLabel,
        allDay:false,
        start:slot.start,
        end:slot.end,
        color:'#0000ff'
      })
      console.log(data1,"JKKKAL")
      setData(data1)
    }
    const onchooseThisRange =()=>{
      console.log(selectedDate,"JKKKAL")
      props.onChangeRange({
        ...selectedDate,
        ansvarig:ansvarig
      })
      handleClose()
    }
    const onchangeHanelansvarig =(currenrAnsvarig)=>{
      setansvarig(currenrAnsvarig)
      let userlist = []
      userlist.push(currenrAnsvarig)
      dispatch(getMoteByUserIDByDate33(auth.user_Afid,auth.user_id,userlist,dateRange.start,dateRange.end,()=>{
        setisLoading(true)
      },()=>{
        setisLoading(false)
      }))
    }
    console.log(isLoading,"DDDDDDASD")
    return (
        <div>
            <Button variant="outlined" color="primary" onClick={handleClickOpen}>
            <IntlMessages id="Label.Responsible.Calender"/>
            </Button>
            {open === true?
            <Dialog onClose={handleClose} 
            aria-labelledby="simple-dialog-title" open={open}
            fullWidth
            maxWidth="lg"
            >
              <div className="p-2 my-2"  style={{ height: 'auto', maxWidth:300 }}>
              <SelectMedArbetare
              Ansvarig={ansvarig}
              onchangeHanelansvarig={onchangeHanelansvarig}                    
              />
              </div>
              {
                isLoading === true?
                <Skeleton variant="rect" width={952} height={600} style={{padding: "20px", margin:`5px auto`}}/>
                :
                <BigCalendar
                localizer={localizer}
                style={{ height: 900,width:"100%", padding: "20px" }}
                events={data}
                step={15}
                view={"week"}
                onView={() => {}}
                tooltipAccessor={(e) => e.tooltip}
                min={minTime}
                defaultDate={new Date()}
                date={dateRange.start}
                messages={messages}
                popup={true}
                onNavigate={handleNavigate}
                components={{
                    toolbar: CustomToolbar
                }}
                eventPropGetter={event=>({
                  style:{
                    backgroundColor:event.color,
                    borderRadius:0,
                    fontSize:16
                  }
              })}
                selectable={true}
                onSelectSlot={onSelectSlot}
                onSelectEvent={event => {
                  console.log("E")
                }}
                />
              }
                <div className="d-flex w-100 p-2 my-2">
                <div>
                  <Button
                  onClick={handleClose}
                  className="jr-btn"
                  variant="outlined"
                  color="default"
                  ><IntlMessages id="Cancel"/></Button>
                </div>
                <div className="ml-auto">
                  <Button
                  variant="contained"
                  color="primary"
                  className="jr-btn"
                  onClick={onchooseThisRange}
                  ><IntlMessages id="Label.Choose.date"/></Button>
                </div>
                </div>
            </Dialog>
            :""}
        </div>
    );
}

export default injectIntl(AnsvarigDateRange);